import { createAction } from 'redux-dry-ts-actions';
export const actions = {
  setPage: createAction('SET_PAGE', page => page),
  getDocument: createAction('GET_DOCUMENT'),
  getDocumentSuccess: createAction('GET_DOCUMENT_SUCCESS', doc => doc),
  getDocumentFailure: createAction('GET_DOCUMENT_FAILURE', error => error),
  getUnifiedPrivacyWithUserPermissions: createAction('GET_UNIFIED_PRIVACY_WITH_USER_PERMISSIONS'),
  getUnifiedPrivacyWithUserPermissionsSuccess: createAction('GET_UNIFIED_PRIVACY_WITH_USER_PERMISSIONS_SUCCESS', up => up),
  getUnifiedPrivacyWithUserPermissionsFailure: createAction('GET_UNIFIED_PRIVACY_WITH_USER_PERMISSIONS_FAILURE', error => error),
  getFeatureSwitches: createAction('GET_FEATURE_SWITCHES'),
  getFeatureSwitchesSuccess: createAction('GET_FEATURE_SWITCHES_SUCCESS', fs => fs),
  getFeatureSwitchesFailure: createAction('GET_FEATURE_SWITCHES_FAILURE', error => error),
  updateDocument: createAction('UPDATE_DOCUMENT', (oid, doc, tags, redirectPage) => ({
    oid,
    item: doc,
    tags,
    redirectPage
  })),
  updateDocumentSuccess: createAction('UPDATE_DOCUMENT_SUCCESS', (doc, redirectPage) => ({
    item: doc,
    redirectPage
  })),
  updateDocumentFailure: createAction('UPDATE_DOCUMENT_FAILURE', error => error),
  getCollaborators: createAction('GET_COLLABORATORS'),
  getCollaboratorsSuccess: createAction('GET_COLLABORATORS_SUCCESS', collaborators => collaborators),
  getCollaboratorsFailure: createAction('GET_COLLABORATORS_FAILURE', error => error),
  updateCollaborator: createAction('UPDATE_COLLABORATOR', (email, permission) => ({
    email,
    permission
  })),
  updateCollaboratorSuccess: createAction('UPDATE_COLLABORATOR_SUCCESS', udpatedCollaborator => udpatedCollaborator),
  updateCollaboratorFailure: createAction('UPDATE_COLLABORATOR_FAILURE', error => error),
  removeCollaborator: createAction('REMOVE_COLLABORATOR', email => email),
  removeCollaboratorSuccess: createAction('REMOVE_COLLABORATOR_SUCCESS', email => email),
  removeCollaboratorFailure: createAction('REMOVE_COLLABORATOR_FAILURE', error => error),
  updateOrganization: createAction('UPDATE_TEAM', permission => permission),
  updateOrganizationSuccess: createAction('UPDATE_TEAM_SUCCESS', team => team),
  updateOrganizationFailure: createAction('UPDATE_TEAM_FAILURE', error => error),
  removeOrganization: createAction('REMOVE_TEAM'),
  removeOrganizationSuccess: createAction('REMOVE_TEAM_SUCCESS'),
  removeOrganizationFailure: createAction('REMOVE_TEAM_FAILURE', error => error),
  getContacts: createAction('GET_CONTACTS'),
  getContactsSuccess: createAction('GET_CONTACTS_SUCCESS', contacts => contacts),
  getContactsFailure: createAction('GET_CONTACTS_FAILURE', error => error),
  getUnlistedLink: createAction('GET_UNLISTED_LINK'),
  getUnlistedLinkSuccess: createAction('GET_UNLISTED_LINK_SUCCESS', unlistedLink => unlistedLink),
  getUnlistedLinkFailure: createAction('GET_UNLISTED_LINK_FAILURE', error => error),
  generateUnlistedLink: createAction('GENERATE_UNLISTED_LINK'),
  generateUnlistedLinkSuccess: createAction('GENERATE_UNLISTED_LINK_SUCCESS', unlistedLink => unlistedLink),
  generateUnlistedLinkFailure: createAction('GENERATE_UNLISTED_LINK_FAILURE', error => error),
  deleteUnlistedLink: createAction('DELETE_UNLISTED_LINK'),
  deleteUnlistedLinkSuccess: createAction('DELETE_UNLISTED_LINK_SUCCESS', unlistedLink => unlistedLink),
  deleteUnlistedLinkFailure: createAction('DELETE_UNLISTED_LINK_FAILURE', error => error),
  reloadPage: createAction('RELOAD_PAGE'),
  getFolderDetails: createAction('GET_FOLDER_DETAILS', folderUuid => ({
    folderUuid
  })),
  getFolderDetailsSuccess: createAction('GET_FOLDER_DETAILS_SUCCESS', (folderUuid, details) => ({
    folderUuid,
    details
  })),
  getFolderCollaboratorsSuccess: createAction('GET_FOLDER_COLLABORATORS_SUCCESS', collaborators => collaborators),
  addFolderCollaborator: createAction('UPDATE_FOLDER_COLLABORATOR', (email, folderUuid, successCallback) => ({
    email,
    folderUuid,
    successCallback
  })),
  removeFolderCollaborator: createAction('REMOVE_FOLDER_COLLABORATOR', (collaboratorId, folderUuid, isRemovingSelf) => ({
    collaboratorId,
    folderUuid,
    isRemovingSelf
  })),
  updateFolderCollaboratorSuccess: createAction('UPDATE_FOLDER_COLLABORATOR_SUCCESS', folderUuid => ({
    folderUuid
  })),
  folderCollaboratorsError: createAction('FOLDER_COLLABORATORS_ERROR', error => error),
  addFolderCollaboratorError: createAction('ADD_FOLDER_COLLABORATOR_ERROR', (folderUuid, error) => ({
    folderUuid,
    error
  })),
  logOpenCopyEmbedCode: createAction('LOG_OPEN_COPY_EMBED_CODE')
};